export function findLastElements<T>(array: T[], count: number): T[] {
    if (array.length <= count) {
        return array
    }

    return array.splice(-count);
}
